import React, { createContext, useContext, useState } from 'react';
import { CreateBody, CreateBrand, CreateEngine, CreateModel, DeleteBrands, UpdateBrands, UpdateCarBody, fetchBodyType, fetchBrand, fetchEngineClass, fetchModel,DeleteBody, UpdateModels, UpdatedModels, DeleteModels, DeleteEngine, UpdateEngine } from '../../services/api';

const CarContext = createContext();

export const CarProvider = ({ children }) => {
    const [brands, setBrands] = useState([]);
    const [models, setModels] = useState([]);
    const [body, setBody] = useState([]);
    const [engine, setEngine] = useState([]);
    // State for Edit Dialog
    const [editOpen, setEditOpen] = useState(false);
    const [editType, setEditType] = useState('brand'); // 'brand' or 'model'
    const [currentEditData, setCurrentEditData] = useState(null);
    const [updated, setUpdated] = useState(null);
  
    const AddBrands = async (brand,file) => {       
        const result = await CreateBrand(brand,file);
        setBrands(result.data); 
    };
    const FetchBrands = async() => {
        const response =await fetchBrand();
        setBrands(response.data);
    };
    const FetchModels = async () => {
      
        const response = await fetchModel();
        setModels(response.data);
    };
    const FetchBodyType = async () => {
        const response = await fetchBodyType();
        setBody(response.data);
    };
    const AddBody = async (body) => {       
        const result = await CreateBody(body);
        setBody(result.data); 
        
    };
    const FetchEngineClass = async () => {
        const response = await fetchEngineClass();
        setEngine(response.data);
    }
    const AddEngine = async (engine) => {       
        const result = await CreateEngine(engine);
        setEngine(result.data); 
    };
    const AddModel = async (models) => {       
        const result = await CreateModel(models);
        setModels(result.data); 
    };
    const DeleteBrand = async (brands) => {       
        const result = await DeleteBrands(brands);
        setBrands(result.data); 
    };
    const DeleteModel = async (model) => {       
        const result = await DeleteModels(model);
        setModels(result.data); 
    };
    const UpdateBrand = async (brands) => {       
        const result = await UpdateBrands(brands);
        setBrands(result.data); 
    };
    const UpdateBody = async (brands) => {
    
        const result = await UpdateCarBody(brands);
        setBody(result.data);
    };
    const editBrand = (brand) => {        
        setEditType('brand');
        setCurrentEditData(brand);
        setEditOpen(true);
    };
    const editBody = (bodytypeId) => {
        setEditType('body');
        setCurrentEditData(bodytypeId);
        setEditOpen(true);
    };
    const DeleteBodyType = async (body) => {       
        const result = await DeleteBody(body)
        setBody(result.data); 
    };
    const DeleteEngineClass = async (engine) => {       
        const result = await DeleteEngine(engine)
        setEngine(result.data); 
    };
    const UpdateEngineClass = async (engine) => {    
       
        const result = await UpdateEngine(engine);
        setEngine(result.data); 
    };
    const editEngine = (engine) => {
       
        setEditType('engine');
        setCurrentEditData(engine);
        setEditOpen(true);
    };
    const UpdateModel = async (model) => {    
        
        const result = await UpdatedModels(model);
        setModels(result.data); 
    };

    const editModel = (model) => {   
           
        setEditType('model');
        setCurrentEditData(model);
        console.log(model)
        setEditOpen(true);
       
    };
    
    return (
        <CarContext.Provider value={{ AddBrands,UpdateEngineClass,editEngine, AddBody,DeleteEngineClass, brands,DeleteModel, models,editModel,UpdateModel, setBrands, FetchBrands, FetchModels, body, FetchBodyType, FetchEngineClass, engine, AddEngine, AddModel, DeleteBrand, UpdateBrand, editBrand, editOpen, editType, currentEditData, setEditOpen, setEditType, setCurrentEditData, editBody, UpdateBody,DeleteBodyType }}>
            {children}
        </CarContext.Provider>
    );
};

export const useCarContext = () => useContext(CarContext);
